import React, { useState, useEffect } from "react";
import { Dropdown,
    DefaultButton,
    PrimaryButton,
    Dialog,
    DialogType,
    Panel,
    PanelType,
    Toggle,
    SpinButton } from "@fluentui/react";
import Axios from "axios";
import { Icon } from "@fluentui/react/lib/Icon";
// import "../../Styles/VTNETFrame.css";
import { Snackbar, Alert } from "@mui/material";
const CloudProVTNETFrame = ({ setShowComponent, project }) => {
useEffect(() => {
  if (!project?.panel?.VT5000_CONFIG?.generalparameters) return;

  const gp = project.panel.VT5000_CONFIG.generalparameters;

  setPanelNumber(gp.vtnetNetworkPanelNb || 0);
  setPanelAddress(gp.vtnetPanelAddress || 0);
  setAlarmVisible(Boolean(gp.vtnetAlarmVisible));
  setResetEnable(Boolean(gp.vtnetResetEnable));
  setEvacEnable(Boolean(gp.vtnetEvacEnable));
  setFaultVisible(Boolean(gp.vtnetFaultVisible));
}, [project]);
    const [currentTime, setCurrentTime] = useState("");
    const [panelNumber, setPanelNumber] = useState(
  project?.panel?.VT5000_CONFIG?.generalparameters?.vtnetNetworkPanelNb || 0
);

const [panelAddress, setPanelAddress] = useState(
  project?.panel?.VT5000_CONFIG?.generalparameters?.vtnetPanelAddress || 0
);

const [alarmVisible, setAlarmVisible] = useState(
  project?.panel?.VT5000_CONFIG?.generalparameters?.vtnetAlarmVisible
);

const [resetEnable, setResetEnable] = useState(
  project?.panel?.VT5000_CONFIG?.generalparameters?.vtnetResetEnable
);

const [evacEnable, setEvacEnable] = useState(
  project?.panel?.VT5000_CONFIG?.generalparameters?.vtnetEvacEnable
);

const [faultVisible, setFaultVisible] = useState(
  project?.panel?.VT5000_CONFIG?.generalparameters?.vtnetFaultVisible
);
    const [isDevicesDialogOpen, setIsDevicesDialogOpen] = useState(false);
    const [loopPresent, setLoopPresent] = useState(0);
    const [panelType, setPanelType] = useState(0);
    const [selectedPanel, setSelectedPanel] = useState(0);
    const [openSnackbar, setOpenSnackbar] = useState(false);
   const [alertMsg, setAlertMsg] = useState("");
   const [alertType, setAlertType] = useState("success");
  const [identifierError,setIdentifierError]=useState("");

    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            let formattedTime = now.toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            }).replace(/,/g, ""); // Remove comma between date and time

            formattedTime = formattedTime.replace(/(\d{4})\//, "$1 "); // Remove '/' after year
            setCurrentTime(formattedTime);
        };

        updateTime();
        const interval = setInterval(updateTime, 1000);
        return () => clearInterval(interval);
    }, []);
const handlePanelButtonClick = (index) => {
  setSelectedPanel(index);

  const panel =
    project?.panel?.VT5000_CONFIG?.vtnets?.[index];

  if (!panel) return;

  setLoopPresent(panel.loopNb || 0);
  setPanelType(panel.panelType || 0);
};
const rawPanelNumber = project?.panel?.VT5000_CONFIG?.panel_number;
const maxPanelCount = Number(rawPanelNumber) || 0;

console.log("--------"+maxPanelCount)
   const handleSave = async () => {
  

  if (!project?.panel?.VT5000_CONFIG?.generalparameters) {
    console.error("generalparameters not found");
    setOpenSnackbar(true);
             setAlertMsg("generalparameters not found");
        setAlertType("error");

    return;
  }
if (maxPanelCount > 0 && Number(panelNumber) !== maxPanelCount) {
  console.error("Panels in Network does not match the configured panel count");
  setIdentifierError(`Please select the correct panel in network. Panels in network should be ${maxPanelCount}`);
  return;
}
  // Update values
  project.panel.VT5000_CONFIG.generalparameters.vtnetNetworkPanelNb =
    panelNumber;

  project.panel.VT5000_CONFIG.generalparameters.vtnetPanelAddress =
    panelAddress;

  project.panel.VT5000_CONFIG.generalparameters.vtnetAlarmVisible =
    alarmVisible ? 1 : 0;

  project.panel.VT5000_CONFIG.generalparameters.vtnetEvacEnable =
    evacEnable ? 1 : 0;

  project.panel.VT5000_CONFIG.generalparameters.vtnetFaultVisible =
    faultVisible ? 1 : 0;

  project.panel.VT5000_CONFIG.generalparameters.vtnetResetEnable =
    resetEnable ? 1 : 0;

  const payload = {
    projectId: project.project_id,

    panelContentId:
      project?.panel?.VT5000_CONFIG?.panelContent_id ||
      sessionStorage.getItem("panelContentId"),

    generalparameters:
      project.panel.VT5000_CONFIG.generalparameters,

    email: localStorage.getItem("userEmail"),
  };

 if (panelAddress === 0) {
  console.error("Identifier cannot be 0");
  setIdentifierError("Identifier cannot be 0");

  return;
}

  try {
    const response = await Axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/update_panel_generalparameters`,
      payload
    );

    console.log("Response =", response.data);

    if (response.data.success) {
      console.log(
        "VTNET in General Parameters updated successfully"
      );
        setOpenSnackbar(true);
        setAlertMsg("VTNET in General Parameters updated successfully");
        setAlertType("success");
        setShowComponent(false)

    } else {
      console.error(
        "Failed to update VTNET in General Parameters"
      );
      setOpenSnackbar(true);
        setAlertMsg("Failed to update VTNET in General Parameters");
        setAlertType("error");
    }
  } catch (error) {
    console.error(
      "Error updating VTNET in General Parameters:",
      error
    );
    setOpenSnackbar(true);
        setAlertMsg("Error updating VTNET in General Parameters:",
      error);
        setAlertType("error");
  }
};

const handleSaveVTNET = async () => {
  

  if (!project?.panel?.VT5000_CONFIG?.vtnets) {
    console.error("vtnets not found");
    setOpenSnackbar(true);
    setAlertMsg("vtnets not found");
    setAlertType("error");

    return;
  }

  // Update selected panel values
  project.panel.VT5000_CONFIG.vtnets[selectedPanel].loopNb = loopPresent;
  project.panel.VT5000_CONFIG.vtnets[selectedPanel].panelType = panelType;


  const payload = {
    projectId: project.project_id,
    panelContentId:
      project?.panel?.VT5000_CONFIG?.panelContent_id ||
      sessionStorage.getItem("panelContentId"),

    vtnets: project.panel.VT5000_CONFIG.vtnets,

    email: localStorage.getItem("userEmail"),
  };



  try {
    

    const response = await Axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/update_panel_vtnets`,
      payload
    );

    console.log("Response =", response.data);

    if (response.data.success) {
      console.log("VTNETs updated successfully");
      setOpenSnackbar(true);
       setAlertMsg("VTNETs updated successfully");
        	setAlertType("success");

      setIsDevicesDialogOpen(false);
    } else {
      console.error("Failed to update VTNETs");
      setOpenSnackbar(true);
       setAlertMsg("Failed to update VTNETs");
        	setAlertType("error")
    }
  } catch (error) {
    console.error("Axios Error =", error);
     setOpenSnackbar(true);
       setAlertMsg("Axios Error =", error);
        	setAlertType("error")
  }
};
    return (
        <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div style={{ fontSize: 20, width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ textAlign: "left", flex: 1 }}>VT-NET</span>
                {/* <span style={{ textAlign: "right", flex: 1 }}>{currentTime}</span> */}
            </div>
           

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", width: "80%" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "15px" }}>Panels in Network</span>
                    <Dropdown
                        placeholder="Select Silence Duration"
                        options={Array.from({ length: 65 }, (_, i) => ({ key: i, text: i.toString() }))}
                        selectedKey={panelNumber}
                        onChange={(e, option) => {
                            setPanelNumber(option.key);
                            if (option.key > 0) {
                              setIsDevicesDialogOpen(true);
                            } else {
                              setIsDevicesDialogOpen(false);
                            }
                          }}
                        onRenderCaretDown={() => <Icon iconName="ChevronDown" styles={{ root: { fontSize: 20 } }} />} // Custom caret down icon
                        styles={{ dropdown: { width: 150 }, callout: { maxHeight: 200 } }}
                    />
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "15px" }}>Identifier</span>
                    <Dropdown
                        placeholder="Select Silence Duration"
                        options={Array.from({ length: panelNumber + 1 }, (_, i) => ({ key: i, text: i.toString() }))}
                        selectedKey={panelAddress}
                        onChange={(e, option) => setPanelAddress(option.key)}
                        onRenderCaretDown={() => <Icon iconName="ChevronDown" styles={{ root: { fontSize: 20 } }} />} // Custom caret down icon
                        styles={{ dropdown: { width: 150 }, callout: { maxHeight: 200 } }}
                    />
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "5px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "15px" }}>Reset Silence</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", alignSelf: "center" }}>
                        <Toggle
                            checked={resetEnable}
                            onChange={() => setResetEnable(!resetEnable)}
                            styles={{ pill: { background: resetEnable ? "#C00D0D" : "#FFF" }, root: { alignSelf: "center" } }}
                        />
                        <span style={{ fontSize: "15px", fontWeight: "bold" }}>{resetEnable ? "Yes" : "No"}</span>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "5px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "15px" }}>Evacuation</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", alignSelf: "center" }}>
                        <Toggle
                            checked={evacEnable}
                            onChange={() => setEvacEnable(!evacEnable)}
                            styles={{ pill: { background: evacEnable ? "#C00D0D" : "#FFF" }, root: { alignSelf: "center" } }}
                        />
                        <span style={{ fontSize: "15px", fontWeight: "bold" }}>{evacEnable ? "Yes" : "No"}</span>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "5px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "15px" }}>View Alarms</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", alignSelf: "center" }}>
                        <Toggle
                            checked={alarmVisible}
                            onChange={() => setAlarmVisible(!alarmVisible)}
                            styles={{ pill: { background: alarmVisible ? "#C00D0D" : "#FFF" }, root: { alignSelf: "center" } }}
                        />
                        <span style={{ fontSize: "15px", fontWeight: "bold" }}>{alarmVisible ? "Yes" : "No"}</span>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "5px", width: "100%", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "15px" }}>Faults</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", alignSelf: "center" }}>
                        <Toggle
                            checked={faultVisible}
                            onChange={() => setFaultVisible(!faultVisible)}
                            styles={{ pill: { background: faultVisible ? "#C00D0D" : "#FFF" }, root: { alignSelf: "center" } }}
                        />
                        <span style={{ fontSize: "15px", fontWeight: "bold" }}>{faultVisible ? "Yes" : "No"}</span>
                    </div>
                    
                </div>

                {identifierError && (
                  <span style={{ color: "#C00D0D", fontSize: "15px", width: "100%" }}>{identifierError}</span>
                )}

                 <div style={{ display: "flex", alignItems: "center", gap: "5px", width: "100%" }}>
                <button className="add-btn" onClick={handleSave}>Save</button>
                <button className="cancel-btn" onClick={() => setShowComponent(false)}>Cancel</button></div>
            </div>

            <Dialog
                hidden={!isDevicesDialogOpen}
                onDismiss={() => setIsDevicesDialogOpen(false)}
                dialogContentProps={{
                    type: DialogType.normal,
                }}
                minWidth={"1000px"}
            >
                <div>
                    <div className="devices-content">
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", width: "100%", marginTop: "10px" }}>
                            <span style={{ fontSize: "20px" }}>Model</span>
                            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                                {[
                                    { label: "VT5000", value: 1 },
                                    { label: "Vita", value: 2 }
                                ].map(({ label, value }) => (
                                    <div
                                        key={label}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100px",
                                            height: "30px",
                                            border: "2px solid black",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            background: panelType === value ? "#C00D0D" : "#FFF"
                                        }}
                                        onClick={() => setPanelType(panelType === value ? 0 : value)} // toggle logic
                                    >
                                        <span style={{
                                            fontSize: "20px",
                                            fontWeight: "bold",
                                            color: panelType === value ? "#FFF" : "#000"
                                        }}>
                                            {label}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                            <div
  className="loop-present-buttons"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "5px",
    flexWrap: "wrap",
  }}
>
  <span>Loop Present:</span>

  {Array.from({ length: 9 }, (_, index) => {
    const value = index + 1;
    const isSelected = loopPresent === value;

    return (
      <button
        key={index}
        style={{
          borderRadius: "15px",
          border: "1px solid red",
          background: isSelected ? "red" : "white",
          color: isSelected ? "white" : "black",
         
        }}
        onClick={() => setLoopPresent(isSelected ? 0 : value)}
      >
        {value}
      </button>
    );
  })}
</div>
                            <div style={{ display: "flex", gap: "10px" }}>
                                <PrimaryButton text="Save" onClick={() => handleSaveVTNET()} />
                                <DefaultButton text="Back" onClick={() => setIsDevicesDialogOpen(false)} />
                            </div>
                        </div>
                        <div className="panel-buttons-container">
                            <div className="panel-buttons-frame">
                                {Array.from({ length: 64 }, (_, index) => {
                                    return (
                                        <button
                                            key={index}
                                            className={`panel-button ${(index < panelNumber && index + 1 !== panelAddress) ? "programmed" : "not-programmed"} ${(index === selectedPanel) ? "selected" : ""}`}
                                            disabled={index >= panelNumber || index + 1 === panelAddress}
                                            onClick={() => handlePanelButtonClick(index)}
                                        >
                                            <span>{index + 1}</span>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <div style={{ display: "flex", width: "98%", justifyContent: "space-evenly", position: "absolute", bottom: "2%" }}>
               
            </div>
            <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={alertType}
          variant="filled"
        >
          {alertMsg}
        </Alert>
      </Snackbar>

        </div>
    );
};

export default CloudProVTNETFrame;